'use strict';

var React = require('react');
var styleHelper = require('../../helper/styleHelper');
var util = require('../../helper/util');

var Border = require('../common/Border');
var appTypes = require('../../types/appTypes');
var assetsHelper = require('../../helper/assetsHelper');
var LabelParts = require('../common/LabelParts');
var AutoSizeHelper = require('../common/AutoSizeHelper');
var VerticalScrollBar = require('../common/VerticalScrollBar');
var ColorImage = require('../common/ColorImage');

var NodeType = {None: 1, Expansion: 2, Close: 3, File: 4};

var TreeItem = React.createClass({
  propTypes: {
    selected: React.PropTypes.bool.isRequired,
    data: React.PropTypes.object.isRequired,
    itemHeight: React.PropTypes.number.isRequired,
    onClickEvent: React.PropTypes.func.isRequired
  },

  render: function () {
    var imgStyle;
    var imgSourceUri;
    var textStyle;
    var imgSize;

    var backgroundStyle = {
      width: '100%',
      height: this.props.itemHeight,
      backgroundColor: this.props.selected ? this.props.selectedColor : undefined
    };

    if (this.props.data.nodeType === NodeType.Close) {
      imgSourceUri = assetsHelper.getComponentAsset('SquaredMinus');
      imgSize = 17;
    } else if (this.props.data.nodeType === NodeType.Expansion) {
      imgSourceUri = assetsHelper.getComponentAsset('SquaredPlus');
      imgSize = 17;
    } else {
      imgSourceUri = assetsHelper.getComponentAsset('File');
      imgSize = 20;
    }

    imgStyle = {
      float: 'left',
      width: imgSize,
      height: imgSize,
      marginLeft: 4 + this.props.data.hierarchy * 20,
      marginTop: (this.props.itemHeight - imgSize) / 2
    };


    textStyle = {
      lineHeight: this.props.itemHeight + 'px'
    };
    return (<div style={backgroundStyle} onClick={this.props.onClickEvent}>
      <ColorImage style={imgStyle}
                  src={imgSourceUri}
                  color={this.props.textColor}
      />
      <label style={textStyle}>
        {util.Text.convertSpaceToNbsp(this.props.data.text)}
      </label>
    </div>);
  }
});

var Tree = React.createClass({

  _parseItemText: function (text) {
    var resultObj = {
      hierarchy: 0,
      nodeType: NodeType.None,
      text: ''
    };

    var length = text.length;
    var index = 0;
    var bracket = false;
    var ch;
    var isLoop = true;

    while ((index < length) && isLoop) {
      ch = text.charAt(index);
      switch (ch) {
        case '.':
          resultObj.hierarchy = resultObj.hierarchy + 1;
          break;
        case '[':
          bracket = true;
          break;
        case ']':
          bracket = false;
          isLoop = false;
          break;
        case '+':
          if (bracket) {
            resultObj.nodeType = NodeType.Expansion;
          } else {
            isLoop = false;
          }
          break;
        case '-':
          if (bracket) {
            resultObj.nodeType = NodeType.Close;
          } else {
            resultObj.nodeType = NodeType.File;
            isLoop = false;
          }
          break;
        default:
          isLoop = false;
      }
      index = index + 1;
    }

    resultObj.text = text.substring(index, text.length);

    return resultObj;

  },

  _getItemArray: function () {
    var resultArray = [];
    var textArray = util.Text.delimitText(util.Text.removeLastEmptyRow(styleHelper.getText(this.props)),util.Text.DM_RETURN);

    textArray.forEach(function (text) {
      resultArray.push(this._parseItemText(text.trim()));
    }.bind(this));

    return resultArray;
  },

  getInitialState: function () {
    return {
      selectedIndex: this.props.selectedIndex
    };
  },

  componentWillMount: function () {
    var size = AutoSizeHelper.getComAutoSize(this.props, '^p');
    this.itemHeight = Math.round(size.height + 2 * 7.8);
  },

  render: function () {
    var itemArray = this._getItemArray();
    var borderStyle = styleHelper.StyleUtil(this.props).text().border().size().base().background().style;
    return (<div style={borderStyle}>
      <div style={{
        height: '100%',
        width:this.props.verticalScrollbarShow?(styleHelper.getWidth(this.props) - 16):'100%'
      }}>
        {
          itemArray.map(function (item, index) {
            return (<TreeItem {...this.props}
              key={index}
              data={item}
              selected={index === this.state.selectedIndex}
              itemHeight={this.itemHeight}
              onClickEvent={this._onClick.bind(this, null, index)}
            />);
          }.bind(this))
        }
      </div>
      {
        this.props.verticalScrollbarShow &&
        <VerticalScrollBar value={parseInt(this.props.verticalScrollbarProgress, 10)}/>
      }
    </div>);
  },

  _onClick: function (e, index) {
    this.setState({selectedIndex: index});
  },

  componentDidMount: function () {
    $(ReactDOM.findDOMNode(this)).bind('itemClick', this._onClick);
  }
});


module.exports = Tree;



/** WEBPACK FOOTER **
 ** ./src/views/Components/Tree.jsx
 **/